import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthService} from "../../modules/auth/services/auth.service";
import {UserService} from "../../core/services/user.service";
import {HttpClientModule} from "@angular/common/http";
import {TuiButtonModule, TuiDropdownModule, TuiRootModule} from "@taiga-ui/core";
import {TuiActiveZoneModule, TuiObscuredModule} from "@taiga-ui/cdk";
import {CommonModule} from "@angular/common";
import {SETTINGS} from "../../core/config/common.settings";

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    HttpClientModule,
    TuiButtonModule,
    TuiRootModule,
    TuiDropdownModule,
    TuiActiveZoneModule,
    TuiObscuredModule,
    CommonModule
  ],
  providers: [
    AuthService,
    UserService
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss'
})
export class TopBarComponent implements OnInit {

  open = false;

  loggedInUser: any = {};
  loggedUser: any;
  loggedInUserName = '';

  constructor(private authService: AuthService, private userService: UserService,private cdr: ChangeDetectorRef) {
  }


  async ngOnInit(): Promise<any> {
    this.loggedUser = this.authService.getLoggedInUser()
    this.userService.loggedInUserNameSubject.subscribe({
      next: (value) => {
        this.loggedInUserName = value;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.log(err);
      },
    });

    await this.userService.getOneUser(this.loggedUser.userId).then((res) => {
      this.loggedInUser = res;
      this.userService.loggedInUserNameSubject.next(
        `${this.loggedInUser?.firstname} ${this.loggedInUser?.lastname}`,
      );
      })
  }


  protected readonly SETTINGS = SETTINGS;
}
